import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from "../../../assets/images/logo_kkp.jpg";
import srcArial from "../../../assets/custom/font/arial/arial.ttf";
import srcArialBold from "../../../assets/custom/font/arial/ARIBL0.ttf";
import NonlalinService from "../../../services/nonlalin/NonlalinService";
import MasterService from "../../../services/master/MasterService";
import UserService from "../../../services/user/UserService";
import { formatDateStringLocalDateINA, getNamaUPTBaru } from "../../../utilities/Utils";
import Kemasan from "../../../utilities/Kemasan";

Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "Arial-Bold", src: srcArialBold });

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingBottom: 40,
    paddingHorizontal: 40,
    fontFamily: "Arial",
  },
  headerLogo: {
    width: 80,
    height: 80,
  },
  centerText: {
    textAlign: "center",
  },
  title: {
    fontFamily: "Arial-Bold",
    fontSize: 14,
    textAlign: "center",
    marginTop: 4,
  },
  subtitle: {
    fontSize: 12,
    textAlign: "center",
  },
  sectionTitle: {
    fontFamily: "Arial-Bold",
    fontSize: 12,
    marginTop: 2,
    marginBottom: 2,
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderColor: "#000",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  table1: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColKey: {
    width: "30%",
    paddingLeft: 8,
    paddingTop: 3,
  },
  tableColSeparator: {
    width: "5%",
    paddingTop: 3
  },
  tableColValue: {
    width: "65%",
    paddingTop: 3,
  },
  text: {
    fontSize: 10,
  },
  tableSampleHeader: {
    flexDirection: "row",
    backgroundColor: "#f2f2f2",
  },
  tableCell: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    padding: 3,
    fontSize: 9,
    textAlign: "center",
  },
});

const Header = () => <View
  fixed
  style={{
    display: "table",
    width: "100%",
    border: "1 solid #000",
    marginBottom: 10,
  }}
>

  <View style={{ flexDirection: "row", alignItems: "center" }}>
    <View
      style={{
        width: "25%",
        borderRight: "1 solid #000",
        alignItems: "center",
        justifyContent: "center",
        padding: 4,
      }}
    >
      <Image src={imgKkp} style={{ width: 80, height: 70 }} />
    </View>

    <View
      style={{
        width: "75%",
        alignItems: "center",
        justifyContent: "center",
        padding: 6,
      }}
    >
      <Text
        style={{
          fontFamily: "Arial-Bold",
          fontSize: 12,
          textAlign: "center",
        }}
      >
        KEMENTERIAN KELAUTAN DAN PERIKANAN
      </Text>
      <Text
        style={{
          fontFamily: "Arial-Bold",
          fontSize: 12,
          textAlign: "center",
        }}
      >
        BADAN PENGENDALIAN DAN PENGAWASAN MUTU HASIL KELAUTAN DAN PERIKANAN
      </Text>
    </View>
  </View>

  <View
    style={{
      borderTop: "1 solid #000",
      paddingVertical: 4,
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Text
      style={{
        fontFamily: "Arial-Bold",
        fontSize: 11,
        textAlign: "center",
      }}
    >
      FORMULIR PERMOHONAN 
    </Text>
    <Text
      style={{
        fontFamily: "Arial-Bold",
        fontSize: 11,
        textAlign: "center",
      }}
    >
      LAYANAN LABORATORIUM PENGUJIAN MUTU
    </Text>
  </View>
</View>;

const FormPermohanan = ({ datappm }) => {

  let nonLalinService = useMemo(() => new NonlalinService(), [])
  let masterService = useMemo(() => new MasterService(), [])
  let userService = useMemo(() => new UserService(), [])

  const [listDetil, setListDetil] = useState(null)
  const [listKemasan, setListKemasan] = useState(null)
  const [jenisKomoditi, setJenisKomoditi] = useState(null)
  const [maksudKegiatan, setMaksudKegiatan] = useState(null)
  const [upt, setUpt] = useState(null)
  const [listPeriksa, setListPeriksa] = useState(null)

  const fetchAllData = useCallback(async () => {
    if (!datappm?.nomorAju) {
      return
    }

    try {
      const results = await Promise.allSettled([
        nonLalinService.listNonlalinDtlAll(datappm.nomorAju),
        nonLalinService.listNonlalinKemasanAll(datappm.nomorAju),
        masterService.getJenisKomoditiById(datappm.jenisKomoditi),
        nonLalinService.getRefNonlalinMaksudKegiatanById(datappm.maksudKegiatan),
        userService.getUptById(datappm.kodeUpt),
        nonLalinService.listNonlalinDtlPeriksaAll(datappm.nomorAju, datappm.seri)
      ])

      const [resDetil, resKemasan, resJenisKomoditi, resMaksud, resUpt, resPeriksa] = results

      const getData = (res, fallback = []) =>
        res.status === "fulfilled"
          ? res.value?.data?.data ?? res.value?.data ?? fallback
          : fallback;

      setListDetil(getData(resDetil))
      setListKemasan(getData(resKemasan))
      setJenisKomoditi(getData(resJenisKomoditi))
      setMaksudKegiatan(getData(resMaksud))
      setUpt(getData(resUpt))
      setListPeriksa(getData(resPeriksa.data.data))
    } catch (error) {

    }
  }, [nonLalinService, masterService, userService, datappm])

  console.log(listPeriksa)
  useEffect(() => {
    let isMounted = true
    if (!datappm) return

    const loadData = async () => {
      try {
        await fetchAllData();
      } catch (e) {
        if (isMounted) console.error(e);
      }
    };

    loadData();

    return () => { isMounted = false; };
  }, [datappm, fetchAllData]);

  const [dateNow] = useState(new Date().toLocaleDateString("id-ID"));

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <view>
          <Header />
        </view>

        {/*  A - DATA PERMOHONAN */}
        <View style={{ border: "1 solid #000", padding: 4, paddingBottom: 10 }}>
          <Text style={styles.sectionTitle}>A. DATA PERMOHONAN</Text>
          <View style={styles.table}>
            {[
              ["Nomor Pengajuan", datappm.nomorAju],
              ["Jenis Komoditi", jenisKomoditi ? jenisKomoditi.jenisKomoditi : ''],
              ["Maksud Kegiatan", maksudKegiatan ? maksudKegiatan.urMaksudKegiatan : ''],
              ["UPT", upt ? getNamaUPTBaru(datappm.tanggalAju, upt) : ''],
              ["Tempat Periksa", datappm.tempatPeriksa],
              ["Tanggal Rencana Scanning", formatDateStringLocalDateINA(datappm.tanggalMasukSample)],

            ].map(([label, value], i) => (
              <View key={i} style={styles.tableRow}>
                <View style={styles.tableColKey}>
                  <Text style={styles.text}>{label}</Text>
                </View>
                <View style={styles.tableColSeparator}>
                  <Text style={styles.text}>:</Text>
                </View>
                <View style={styles.tableColValue}>
                  <Text style={styles.text}>{value}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>


        <View style={{ border: "1 solid #000", padding: 4, borderTop: "0 solid #000", paddingBottom: 10 }}>
          <Text style={styles.sectionTitle}>B. PEMILIK BARANG</Text>
          <View style={styles.table}>
            {[
              ["NPWP", datappm.npwpTrader],
              ["Nama", datappm.namaTrader],
              ["Alamat", datappm.alamatTrader],
              ["Kode Pos", datappm.kodeposTrader],
              ["No. Telepon", datappm.teleponCp],
            ].map(([label, value], i) => (
              <View key={i} style={styles.tableRow}>
                <View style={styles.tableColKey}>
                  <Text style={styles.text}>{label}</Text>
                </View>
                <View style={styles.tableColSeparator}>
                  <Text style={styles.text}>:</Text>
                </View>
                <View style={styles.tableColValue}>
                  <Text style={styles.text}>{value}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>


    <View style={{ border: "1 solid #000", padding: 4, borderTop: "0 solid #000", paddingBottom: 10 }}>
      <Text style={styles.sectionTitle}>C. DETAIL SAMPLE / BARANG</Text>
        <View style={styles.table1}>
        <View style={[styles.tableRow, { backgroundColor: "#eaeaea" }]}>
          {[
            { label: "No", width: "7%" },
            { label: "Kode HS", width: "27%" },
            { label: "Nama Lokal", width: "33%" },
            { label: "Nama Latin", width: "33%" },
          ].map((h, i) => (
            <View
              key={i}
              style={[
                styles.tableCell,
                {
                  width: h.width,
                  borderRightWidth: h.borderRightWidth !== undefined ? h.borderRightWidth : 1,
                  fontFamily: "Arial-Bold",
                  backgroundColor: "#eaeaea",
                },
              ]}
            >
              <Text style={{ fontSize: 9 }}>{h.label}</Text>
            </View>
          ))}
        </View>

        
        {listPeriksa && listPeriksa.map((data, idx) => {
          return (
            <View key={idx} style={{ flexDirection: "column" }}>
              <View style={styles.tableRow}>
                {[
                  { width: "7%", textAlign: "center", value: idx + 1 },
                  { width: "23%", textAlign: "left", value: data.kodeHs },
                  { width: "35%", textAlign: "left", value: data.namaLokal },
                  { width: "35%", textAlign: "center", value: data.namaLatin },
                ].map((col, i) => (
                  <View
                    key={i}
                    style={[
                      styles.tableCell,
                      {
                        width: col.width,
                        textAlign: col.textAlign,
                        paddingVertical: 4,
                        justifyContent: "center",
                        height: 25,
                      },
                    ]}
                  >
                    <Text style={{ fontSize: 9 }}>{col.value}</Text>
                  </View>
                ))}
              </View>
s
              <View style={[styles.tableRow, { backgroundColor: "#f9f9f9" }]}>
              
                <View style={[styles.tableCell, { width: "7%", borderRightWidth: 1 }]}><Text></Text></View> 
                
                <View style={[styles.tableCell, { width: "10%", fontFamily: "Arial-Bold", backgroundColor: "#eaeaea" }]}>
                  <Text style={{ fontSize: 8 }}>No</Text>
                </View>
                <View style={[styles.tableCell, { width: "48%", fontFamily: "Arial-Bold", backgroundColor: "#eaeaea", textAlign: "left" }]}>
                  <Text style={{ fontSize: 8 }}>Jenis Pengujian (Tarif)</Text>
                </View>
                <View style={[styles.tableCell, { width: "35%", fontFamily: "Arial-Bold", backgroundColor: "#eaeaea", textAlign: "left" }]}>
                  <Text style={{ fontSize: 8 }}>Volume / Keterangan</Text>
                </View>
              </View>
            
                <View  style={styles.tableRow}>
                
                  <View style={[styles.tableCell, { width: "7%", borderRightWidth: 1 }]}><Text></Text></View>
                  
                  <View style={[styles.tableCell, { width: "10%", textAlign: "center", height: 20 }]}>
                    <Text style={{ fontSize: 8 }}>1</Text>
                  </View>
                  <View style={[styles.tableCell, { width: "48%", textAlign: "left", height: 20 }]}>
                    <Text style={{ fontSize: 8 }}>Jenis Uji</Text>
                  </View>
                  <View style={[styles.tableCell, { width: "35%", textAlign: "left", height: 20 }]}>
                    <Text style={{ fontSize: 8 }}>Volume</Text>
                  </View>
                </View>
            </View>
          );
        })}
      </View>
    </View>
 
        <View style={{ border: "1 solid #000", padding: 4, borderTop: "0 solid #000", paddingBottom: 10 }}>
          <Text style={styles.sectionTitle}>D. DETAIL KEMASAN</Text>
          <View style={styles.table1}>
            <View style={[styles.tableRow, { backgroundColor: "#eaeaea" }]}>
              {[
                { label: "No", width: "7%" },
                { label: "Jenis Kemasan", width: "27%" },
                { label: "Merk", width: "33%" },
                { label: "Jumlah", width: "33%" },

              ].map((h, i) => (
                <View
                  key={i}
                  style={[
                    styles.tableCell,
                    {
                      width: h.width,
                      borderRightWidth:
                        h.borderRightWidth !== undefined ? h.borderRightWidth : 1,
                      fontFamily: "Arial-Bold",
                      backgroundColor: "#eaeaea",
                    },
                  ]}
                >
                  <Text style={{ fontSize: 9 }}>{h.label}</Text>
                </View>
              ))}
            </View>

            {listKemasan && listKemasan.map((data, idx) => {

              return (
                <View key={idx} style={styles.tableRow}>
                  {[
                    { width: "7%", textAlign: "center", value: idx + 1 },
                    { width: "27%", textAlign: "left", value: (<>{data.kodeKemasan} - <Kemasan id={data.kodeKemasan} /></>) },
                    { width: "33%", textAlign: "left", value: data.merk },
                    { width: "33%", textAlign: "center", value: data.jumlah },

                  ].map((col, i) => (
                    <View
                      key={i}
                      style={[
                        styles.tableCell,
                        {
                          width: col.width,
                          textAlign: col.textAlign,
                          paddingVertical: 4,
                          justifyContent: "center",
                          height: 30,

                        },
                      ]}
                    >
                      <Text style={{ fontSize: 9 }}>{col.value}</Text>
                    </View>
                  ))}
                </View>
              )
            })}
          </View>
        </View>

        <Text style={[styles.text, { marginTop: 10 }]}>
          Tanggal Cetak: {dateNow}
        </Text>
      </Page>


    </Document>
  );
};

// const FormPermohananView = ({ rowData }) => (
//   <PDFViewer width="100%" height="800">
//     <FormPermohanan rowData={rowData} />
//   </PDFViewer>
// );

// export default FormPermohananView;

export default FormPermohanan;